import { styled } from "styled-components";
import { spacers, typography, colors, border, box } from "@joinTrilo/ui/tokens";
import Card from "@joinTrilo/ui/atoms/Card";

// Styles for the Pay component
export const StyledCamelLog = styled(Card)`
    padding: 1.2rem 1.6rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.8rem;
    width: 100%;
`;
export const StyledLogTitle = styled.div`
    font: ${typography.fonts.smallSemiBold};
    line-height: 1.6rem;
`;
export const StyledLogRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
`;
export const StyledLogLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 0.8rem;
`;
export const StyledLogRight = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;
export const StyledLogLogo = styled.div`
    border-radius: ${border.radius.circle};
    width: 3.5rem;
    height: 3.5rem;
    overflow: hidden;
`;
export const StyledLogBrief = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;
export const StyledLogName = styled.div`
    font: ${typography.fonts.subHeadingSmall};
    line-height: 1.9rem;
`;
export const StyledLogNote = styled.div`
    font: ${typography.fonts.smallSemiBold};
    color: ${colors.deepGrey};
    line-height: 1.6rem;
`;
export const StyledLogQuestion = styled.div`
    font: ${typography.fonts.smallSemiBold};
    color: ${colors.darkTurquoise};
    line-height: 1.6rem;
`;
export const StyledLogAmount = styled.div`
    font: ${typography.fonts.subHeadingSmall};
`;

export const StyledCamelCard = styled(Card)`
    padding: 0.8rem 1.6rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 4.8rem;
    width: 100%;
`;

export const StyledCamelSecure = styled(Card)`
    padding: 1.6rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
`;

export const StyledCardTitle = styled.div`
    font: ${typography.fonts.subHeadingSmall};
    color: ${colors.deepGrey};
`;

export const StyledBoost = styled.div`
    font: ${typography.fonts.subHeadingSmall};
`;

export const StyledCamelTop = styled.div`
    font: ${typography.fonts.subHeadingSmall};
`;
export const StyledCamelBottom = styled.div`
    font: ${typography.fonts.subHeadingSmall};
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    align-items: flex-end;
    margin-bottom: 3.2rem;
`;

export const StyledBankLogo = styled.img``;

export const StyledHeaderTab = styled.span<{ isActive?: boolean }>`
    user-select: none;
    cursor: pointer;
    border: solid 1px ${colors.lightSilver};
    height: 3.2rem;
    border-radius: 1.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    padding: 0 ${spacers[2]};
    font: ${typography.fonts.smallSemiBold};
    line-height: ${spacers[2]};
    color: ${colors.deepBlack};
    white-space: nowrap;

    background-color: ${({ isActive }) =>
        isActive ? colors.lightSilver : "transparent"};

    &:hover,
    &:focus {
        outline: none;
    }
`;

export const StyledButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 0.8rem;
    width: 100%;
`;

export const StyledPaymentMethodWrapper = styled(Card)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.6rem;

    height: 5.6rem;
    width: 100%;
`;

export const StyledChangeButton = styled.div`
    font: ${typography.fonts.subHeadingSmall};
    color: ${colors.deepGrey};
`;

export const StyledAuthWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 0.8rem;
    width: 100%;
`;

export const StyledAuthText = styled.div`
    font: ${typography.fonts.smallSemiBold};
    color: ${colors.darkTurquoise};
    text-align: center;
`;

export const StyledPayButton = styled.a<{
    isDisabled: boolean;
    isLoading: boolean;
}>`
    display: flex;
    padding: 1.2rem 0rem;
    justify-content: center;
    align-items: center;
    gap: 0.8rem;
    align-self: stretch;

    width: 100%;
    height: 4.8rem;

    border-radius: 2rem;
    background-color: ${({ isDisabled }) =>
        isDisabled ? colors.lightSilver : colors.darkTurquoise};

    color: ${({ isDisabled }) =>
        isDisabled ? colors.deepBlack : colors.white};
    font: ${typography.fonts.cta};

    box-shadow: ${({ isLoading }) =>
        isLoading ? "none" : box.shadow.primaryButton};

    text-decoration: none;
`;
